"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var react_color_1 = require("react-color");
var CardRowColorPickerEditor = /** @class */ (function (_super) {
    __extends(CardRowColorPickerEditor, _super);
    function CardRowColorPickerEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px" };
        return _this;
    }
    CardRowColorPickerEditor.prototype.componentWillMount = function () {
        this.setState({ show_picker: false });
    };
    // private onValueChange(e: React.ChangeEvent<HTMLInputElement>) {
    //     if (this.props.onValueChanged) {
    //         this.props.onValueChanged(e.target.value);
    //      }
    // }
    CardRowColorPickerEditor.prototype.onButtonClick = function () {
        // if (this.props.onButtonClick) {
        //     this.props.onButtonClick();
        // }
        this.setState({ show_picker: true });
    };
    CardRowColorPickerEditor.prototype.getRequiredMark = function () {
        if (this.props.required) {
            return (React.createElement("div", { style: { color: "#FF0000", marginRight: "2px" } }, "*"));
        }
        return (null);
    };
    CardRowColorPickerEditor.prototype.getErrorMessage = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return (React.createElement("div", { style: { color: "#FF0000", fontSize: "10px", textAlign: "left" } }, this.props.rules.errorMessage));
            }
        }
        return null;
    };
    CardRowColorPickerEditor.prototype.getCSSStyle = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return { borderColor: "#FF0000", borderStyle: "solid", borderWidth: "1px", borderRadius: "4px" };
            }
        }
        return null;
    };
    CardRowColorPickerEditor.prototype.handleClose = function () {
        this.setState({ show_picker: false });
    };
    CardRowColorPickerEditor.prototype.handleChangeComplete = function (color, event) {
        if (this.props.onColorChanged) {
            this.props.onColorChanged(color.hex);
        }
    };
    CardRowColorPickerEditor.prototype.getColorPicker = function () {
        if (this.state.show_picker) {
            return (React.createElement("div", { style: { position: 'absolute', zIndex: 2, } },
                React.createElement("div", { style: {
                        position: 'fixed',
                        top: '0px',
                        right: '0px',
                        bottom: '0px',
                        left: '0px',
                    }, onClick: this.handleClose.bind(this) }),
                React.createElement(react_color_1.ChromePicker, { color: this.props.color, onChangeComplete: this.handleChangeComplete.bind(this) })));
        }
        else {
            return null;
        }
    };
    CardRowColorPickerEditor.prototype.getColorValue = function () {
        return "    " + this.props.color;
    };
    /*<Icon type="star" theme="filled" style={{color: this.props.color}} />*/
    CardRowColorPickerEditor.prototype.render = function () {
        return (React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
            React.createElement(antd_1.Input, { addonBefore: React.createElement("div", { style: {
                        width: "200px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", justifyContent: "center", lineHeight: "30px"
                    } },
                    this.getRequiredMark(),
                    React.createElement("div", null, this.props.texts.caption)), placeholder: this.props.texts.placeholder, value: this.getColorValue(), 
                // onChange={this.onValueChange.bind(this)}
                disabled: this.props.disabled, readOnly: true, 
                //  backg={this.props.color}
                prefix: React.createElement("div", { style: {
                        width: "30px",
                        height: "15px",
                        backgroundColor: this.props.color,
                    } }), addonAfter: React.createElement(antd_1.Tooltip, { placement: "top", title: React.createElement("div", null, this.props.texts.buttonHint), trigger: "hover" },
                    this.getColorPicker(),
                    React.createElement(antd_1.Button, { disabled: this.props.disabled, type: "primary", size: "small", shape: "circle", icon: "bg-colors", ghost: true, onClick: this.onButtonClick.bind(this) })), style: this.getCSSStyle() }),
            this.getErrorMessage()));
    };
    return CardRowColorPickerEditor;
}(React.Component));
exports.default = CardRowColorPickerEditor;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/editors/CardRowColorPickerEditor.tsx
// module id = 830
// module chunks = 0